import React from "react";
import Subscriber from "../../subscriber.class";
import Events from "../../services/events.service";
import Storage from "../../services/storage.service";
import Translations from "../../services/translation";

export default class VatSwitch extends Subscriber {
  
  state = {
    use_vat: true
  };
  
  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("use_vat").subscribe((data) => {
        this.setState({
          use_vat: data,
        });
      })
      );
    }
    
    render() {
    const strings = Translations["keys"][Translations.activeLang];
    return (
      <div className="vmo-vat-checkbox">
        <span className="vmo-vat-checkbox-text">{strings["VAT_CHECKBOX"]}</span>
        <span
          className={
            "vmo-toggle-switch " + (this.state.use_vat ? "vmo-switch-on" : "")
          }
          onClick={() => {
            Events.when_user_click_on_vat_toggle(strings["VAT_CHECKBOX"], !Storage.get("use_vat"));
            Storage.set("use_vat", !Storage.get("use_vat"));
          }}
        ></span>
      </div>
    );
  }
}